import React, { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Layout from "layout";
import { StyledBreadCrumbs } from "@/components/BestSellingProductListPage/styles";
import { PageRoot } from "./styles";
import ProductSection from "@/components/BestSellingProductListPage/ProductSection";
import { useGetPublicCollectionQuery } from "api/productApi";
import Loader from "shared/Loader";

const titleFromSlug = (slug) => {
  if (!slug) return "Collection";
  return slug
    .split("-")
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(" ");
};

const CategoryCollectionPage = () => {
  const { categorySlug } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");

  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearch(search.trim()), 400);
    return () => clearTimeout(t);
  }, [search]);

  const { data, isLoading, isFetching, error } = useGetPublicCollectionQuery(
    {
      slug: categorySlug,
      page: currentPage,
      limit: pageSize,
      type: "BEST_SELLING",
      searchFilter: debouncedSearch || undefined,
    },
    { skip: !categorySlug }
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [categorySlug]);

  useEffect(() => {
    setCurrentPage(1);
  }, [debouncedSearch]);

  useEffect(() => {
    setSearch("");
    setDebouncedSearch("");
  }, [categorySlug]);

  const handlePageChange = (page, size) => {
    if (size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1);
    } else {
      setCurrentPage(page);
    }
  };

  const heading = useMemo(() => {
    const name = data?.category?.name;
    if (name) return `Browse ${name}`;
    return `Browse ${titleFromSlug(categorySlug || "")}`;
  }, [data?.category?.name, categorySlug]);

  const items = [
    { title: <Link to="/home">Product</Link> },
    { title: <Link to="/best-selling-products">Best Selling</Link> },
    { title: <span>{data?.category?.name || titleFromSlug(categorySlug || "")}</span> },
  ];

  if (error) {
    return (
      <Layout>
        <StyledBreadCrumbs items={items} />
        <p style={{ padding: "1rem 2rem" }}>Could not load this collection.</p>
      </Layout>
    );
  }

  return (
    <Layout>
      <PageRoot>
      <StyledBreadCrumbs items={items} />
      <ProductSection
        heading={heading}
        products={data?.products}
        currentPage={currentPage}
        pageSize={pageSize}
        total={data?.total}
        onPageChange={handlePageChange}
        searchValue={search}
        onSearchChange={setSearch}
      />
      <Loader isLoading={isLoading || isFetching} />
      </PageRoot>
    </Layout>
  );
};

export default CategoryCollectionPage;
